<template>
  <ListDropdown
    class="sort-dropdown dropdown--simple"
    placeholder="Sortierung"
    label-on-selection
    :value="value"
    :options="options"
    :disabled="disabled"
    @input="onChange"
  />
</template>

<script>
import { cloneDeep } from 'lodash-es';
import ListDropdown from '@/components/list-dropdown.vue';

const DEFAULT_OPTIONS = [
  {
    label: 'Beliebteste',
    value: { field: 'RECOMMENDATION', direction: 'ASC' },
  },
  {
    label: 'Preis aufsteigend',
    value: { field: 'ONETIME_PRICE', direction: 'ASC' },
  },
  {
    label: 'Preis absteigend',
    value: { field: 'ONETIME_PRICE', direction: 'DESC' },
  },
  {
    label: 'Neu eingetroffen',
    value: { field: 'INSERTED_AT', direction: 'DESC' },
  },
];

const SEARCH_OPTIONS = [
  {
    label: 'Relevanz',
    value: { field: 'RELEVANCE', direction: 'ASC' },
  },
  ...cloneDeep(DEFAULT_OPTIONS),
];

const DEFAULT_VALUE = DEFAULT_OPTIONS[0].value;

export default {
  name: 'SortDropdown',
  components: {
    ListDropdown,
  },
  props: {
    value: {
      type: Object,
      default: () => cloneDeep(DEFAULT_VALUE),
    },
    itemUrl: {
      type: Function,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    searchContext: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change', 'input'],
  computed: {
    options() {
      return this.searchContext ? SEARCH_OPTIONS : DEFAULT_OPTIONS;
    },
  },
  methods: {
    onChange(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    },
  },
};
</script>
